import type { FC } from 'react'
import { formatINR, isNegMoney, type Money as MoneyString } from '@project/contracts'

export interface MoneyProps {
  /** A decimal STRING off the wire. Never a JS number — paise get lost. */
  value: string
  size?: number
  /** Set false in a column that is already headed "₹". */
  symbol?: boolean
}

export const Money: FC<MoneyProps> = ({ value, size = 15, symbol = true }) => {
  const negative = isNegMoney(value as MoneyString)
  return (
    <span
      className={`money num${negative ? ' money--neg' : ''}`}
      style={{ fontSize: size }}
    >
      {formatINR(value, { symbol })}
    </span>
  )
}
